export default {
  quotes(state) {
    if (state.quotes.lenght <= 0) {
      state.quotes = JSON.parse(localStorage.getItem("quotes")) || [];
    }
    return JSON.parse(localStorage.getItem("quotes")) || [];
  },

  getTagAvanzamento(state) {
    return state.tagAvanzamento;
  },

  quote(state) {
    return (id) => state.quotes.find((e) => e._id == id);
  },

  listini(state) {
    if (state.listini.lenght <= 0) {
      state.listini = JSON.parse(localStorage.getItem("listini")) || [];
    }
    return JSON.parse(localStorage.getItem("listini")) || [];
  },

  shouldSkipCheck(state) {
    return state.skipCheck;
  },
  getClientChecked(state) {
    return state.clientChecked;
  }
};
